import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PaperAirplaneIcon as EventShareIcon } from '@heroicons/react/24/outline';
import Header from './Header';
import Date from './Date';
import Creator from './Creator';
import classNames from 'classnames';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '@/dialogs_new/DialogManager';
import Partners from '@/pages/events/Row/Partners';
import Notes from '@/pages/events/Row/Notes';
import StatusTags from '@/pages/events/Row/StatusTags';
import Bookmark from '@/pages/_components/Bookmark';
import Slots from '@/dialogs_new/event_manage/Header/Slots';
import Filled from '@/dialogs_new/event_manage/Header/Filled';
import Site from '@/pages/events/Row/Site';
import { useUser } from '@lore/auth';
import useIsEventShareable from '@/features/share-event/hooks/useIsEventShareable';
import Network from './Network';

export default function Event(props) {
  const { event, className, children } = props;

  const { t } = useTranslation();

  const currentUser = useUser();

  const launch = useDialogLauncher();

  const canShare = useIsEventShareable(event);

  function onClick() {
    if (props.onClick) {
      props.onClick();
    } else {
      launch(DialogManager.EventManage.Config(event.id));
    }
  }

  return (
    <div className={classNames(
      'flex flex-col bg-white',
      'shadow-cs-flat rounded-cs-10',
      '-m-0.5 border-2 border-cs-gray-100',
      'relative overflow-hidden',
      // 'hover:bg-cs-orange-50 cursor-pointer',
      className
    )}>
      {/*<Link to={`/events/${event.id}`} className="absolute w-full h-full" />*/}
      <div className="absolute z-10 top-4 right-4 pt-0.5x pr-0.5x flex items-center gap-3">
        {canShare && (
          <button
            type="button"
            aria-label={t('event_share.cta')}
            className="flex items-center gap-1 text-cs-orange-500 hover:opacity-75"
            onClick={(e) => {
              e.stopPropagation();
              launch(DialogManager.EventShare.Config(event.id));
            }}
          >
            <EventShareIcon className="h-5 w-5 -rotate-[30deg]" aria-hidden="true" />
            <span className="hidden sm:inline text-sm font-semibold">{t('event_share.cta')}</span>
          </button>
        )}
        <Bookmark
          type="event"
          resource={event}
        />
      </div>
      <div className="flex flex-col py-4 px-4 space-y-2 hover:bg-cs-orange-50 cursor-pointer" onClick={onClick}>
        <StatusTags event={event} />
        <div className={classNames('pr-10', canShare && 'pr-20 sm:pr-44')}>
          <Header event={event} />
        </div>
        <div className="flex flex-col sm:flex-row items-start justify-between">
          <div className="flex flex-1 flex-wrap gap-x-4 gap-y-2 mb-2 sm:mb-0">
            <Date event={event} />
            <Slots event={event} />
            <Filled event={event} />
            <Creator event={event} />
            <Site event={event} />
            {currentUser.data.isStaff && (
              <Network event={event} />
            )}
          </div>
          <Partners event={event} />
        </div>
      </div>
      {/*{false && (*/}
      {/*  <div className={classNames(*/}
      {/*    'w-full py-4 px-4',*/}
      {/*    'bg-cs-gray-50',*/}
      {/*    '-mt-px border-t border-cs-gray-100',*/}
      {/*  )}>*/}
      {/*    <Participation event={event} />*/}
      {/*  </div>*/}
      {/*)}*/}
      {/*<Participation event={event} />*/}
      {children}
      <div className="bg-gray-50 p-4">
        <Notes event={event}/>
      </div>
    </div>
  );
}

Event.propTypes = {
  event: PropTypes.shape({
    data: PropTypes.shape({
      activityId: PropTypes.number,
      completed: PropTypes.bool,
      cancelled: PropTypes.bool,
      published: PropTypes.bool,
      specificDate: PropTypes.string,
      date: PropTypes.string,
      endDate: PropTypes.string
    }).isRequired,
    id: PropTypes.number.isRequired
  }).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func
};
